import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=a74f8738&"
import script from "./doctor.vue?vue&type=script&lang=js&"
export * from "./doctor.vue?vue&type=script&lang=js&"
import style0 from "./doctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
